import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import Pagination from '@/components/pagination/Pagination';
import useScrollToTop from '@/hooks/useScrollToTop';
import Results from './Results';
import useFilterCount from '@/hooks/useFilterCount';
import useQuery from './useQuery';
import FilterButton from '@/pages/people-partners/FilterButton';
import PaginationInformation from '@/components/pagination/PaginationInformation';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import useDialogConfig from '@/dialogs-routable/_hooks/useDialogConfig';
import { attributeKeys } from './queryUtils';

Layout.propTypes = {
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired
  }).isRequired
};

export default function Layout(props) {
  const { router } = props;
  const { location } = router;

  const search = queryString.parse(location.search);
  const filterCount = useFilterCount(search, attributeKeys);

  const node = useRef();
  const scrollToTop = useScrollToTop();

  const pageSize = 6;

  const result = useQuery({
    search,
    pageSize
  });

  const launch = useDialogLauncher();
  const config = useDialogConfig();

  function showFilters() {
    launch(DialogManager.FiltersStory.Config(config?.id));
  }

  return (
    <>
      <div ref={node} className="flex justify-between">
        <div className="flex space-x-4">
          {/*<SortBy />*/}
          {/*<NetworkFilter />*/}
          {/*<TypeFilter />*/}
          {/*<DistanceFilter />*/}
        </div>
        <FilterButton
          count={filterCount}
          onClick={showFilters}
        />
      </div>
      <Results result={result} />
      <div className="flex items-center justify-between">
        <PaginationInformation
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
        />
        <Pagination
          pageSize={pageSize}
          totalCount={result.meta?.totalCount}
          onNavigate={() => scrollToTop(node)}
        />
      </div>
    </>
  );
}
